'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var $ = _interopDefault(require('jquery'));
var utils_js = require('../helpers/utils.js');

var SOCIAL_WINDOW_PARAMS = 'width=500,height=400,toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,copyhistory=no,resizable=yes';

function SocialShareButton(el, windowParams) {
  this.$el = utils_js.isJquery(el) ? el : $(el);
  this.url = this.$el.data('shareUrl');
  this.windowParams = windowParams || SOCIAL_WINDOW_PARAMS;
  this.$el.on('click', this.onClick.bind(this));
}

SocialShareButton.prototype.onClick = function (evt) {
  evt.preventDefault();
  window.open(this.url, 'socialWindow', this.windowParams);
};

module.exports = SocialShareButton;
